

import firebase from 'firebase/app';
import "firebase/auth";
import 'firebase/database';
import 'firebase/storage';
import 'firebase/firebase-firestore';

 
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
var secondaryAppConfig = {
  apiKey: "AIzaSyACFZfRlNP6uJRhG0m4xzaNCI1wyLJTH24",
  authDomain: "hojouzate-master-admin.firebaseapp.com",
  projectId: "hojouzate-master-admin",
  storageBucket: "hojouzate-master-admin.appspot.com",
  messagingSenderId: "159372684510",
  appId: "1:159372684510:web:e0054d1fea734a8732e64f",
  measurementId: "G-59M85J9KBR"
  };
 
  
  var Masteradmin = firebase.initializeApp(secondaryAppConfig, "secondary");

  export default Masteradmin;
  
